var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"descriptions-wrap",style:(_vm._f("transRpxStyle")([(_vm.customStyle)]))},[((_vm.title))?_c('div',{staticClass:"descriptions-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"descriptions-main"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }